import Embed from 'quill/blots/embed';

export class EmojiBlot extends Embed {
    static override create(value) {
        const node = super.create({
            text: value,
            value: '',
        });
        if (typeof value === 'object') {
            // EmojiBlot.buildSpan(value, node);
            node.appendChild(value);
        } else if (typeof value === 'string') {
            // TODO: check how it works
            (node as HTMLElement).innerHTML = value;

            return node;
            // let tempValue;
            // try {
            //     tempValue = $(value)[0];
            //     if (tempValue === undefined || tempValue === null) {
            //         tempValue = $('<span>' + value + '</span>')[0];
            //     }

            //     if ((!tempValue && value) || $(tempValue)[0].outerHTML.length < value.length) {
            //         tempValue = $('<span>' + value + '</span>')[0];
            //     }
            // } catch (e) {
            //     tempValue = $('<span>' + value + '</span>')[0];
            // }

            // value = tempValue;

            // node.appendChild(value);

            // EmojiBlot.buildSpan(value, node);
            // const valueObj = emojiMap[value];
            // if (valueObj) {
            //     EmojiBlot.buildSpan(valueObj, node);
            // }
        }

        return node;
    }

    static override value(node) {
        return node.dataset.name;
    }

    // static buildSpan(value, node) {
    //     // node.setAttribute('data-name', value.name);
    //     // let emojiSpan = document.createElement('span');
    //     // emojiSpan.classList.add(this['emojiClass']);
    //     // emojiSpan.classList.add(this['emojiPrefix'] + value.name);
    //     // // emojiSpan.innerText = String.fromCodePoint(+('0x' + value.unicode));
    //     // // alert(value.unicode);
    //     // emojiSpan.innerText = String.fromCodePoint(12);
    //     node.appendChild(value);
    // }
}

EmojiBlot['blotName'] = 'emoji';
EmojiBlot['className'] = 'ql-EmojiBlot';
EmojiBlot['tagName'] = 'span';
